<template>
	<div class="tabWrapper statementsItems">
		<div class="rowTabHead">
			<div class="tabTitle" v-if="isGeneralTitle">{{ textGeneralTitle }}</div>
			<div class="btnWrapper">

				<!--				<custom-btn-->
				<!--						text="Other old"-->
				<!--						custom-class="apply btnManager"-->
				<!--						margin="0"-->
				<!--						@updateEvent="onManager"-->
				<!--				></custom-btn>-->
				<v-btn color="success"
				       @click="onMonthSalaryCreate"
				>
					<svg-sprite width="22" height="22" icon-id="calendar0"></svg-sprite>
					<div class="ml-2">Month salary</div>
				</v-btn>

				<v-btn color="success"
				       @click="onStatementsDefaultCreate"
				>
					<svg-sprite width="22" height="22" icon-id="users0"></svg-sprite>
					<div class="ml-2">Other</div>
				</v-btn>
				<v-btn color="success"
				       @click="onDispatchers"
				>
					<svg-sprite width="22" height="22" icon-id="dispatch"></svg-sprite>
					<div class="ml-2">Dispatchers</div>
				</v-btn>
				<v-btn color="success"
				       @click="onSafety"
				>
					<svg-sprite width="22" height="22" icon-id="safety"></svg-sprite>
					<div class="ml-2">Safety</div>
				</v-btn>

			</div>
		</div>
		<div class="head" v-if="!isStatementCreateForm">
			<div class="item">
				<item-info-row
						icon-id="icon-total"
						:is-item-text="false"
						:is-item-dashed="false"
						value="Total"
						is-flex-start
						margin="0"
				></item-info-row>
				<div class="value">{{ total }}</div>
			</div>
			<div class="item">
				<item-info-row
						icon-id="CreditCardPlus"
						:is-item-text="false"
						:is-item-dashed="false"
						value="Bonus"
						is-flex-start
						margin="0"
				></item-info-row>
				<div class="value">{{ bonus }}</div>
			</div>
			<div class="item">
				<item-info-row
						icon-id="CreditCardMinus"
						:is-item-text="false"
						:is-item-dashed="false"
						value="Charge"
						is-flex-start
						margin="0"
				></item-info-row>
				<div class="value">{{ charge }}</div>
			</div>
			<div class="item">
				<item-info-row
						icon-id="CreditCard"
						:is-item-text="false"
						:is-item-dashed="false"
						value="Salary"
						is-flex-start
						margin="0"
				></item-info-row>
				<div class="value">{{ salary }}</div>
			</div>
		</div>
		<div
				class="main"
				v-if="!isStatementCreateForm"
		>

			<main-table-all-back
					:flag="flag"
					:headers="getHeaders"
					:filtersList="statementsDefaultFilters"
					:list="statementsDefaultRows"
					:defaultOrder="statementsDefaultOrder"
					:defaultSort="statementsDefaultSort"

					:totals="statementsDefaultTotals"
					:total-pages="statementsDefaultTotal"
					:limit-pages="statementsDefaultLimit"
					:pages="[ 15, 50, 100, 200, 500, 'All' ]"
					@updateClickButton="onClickButton"
					@updateList="onList"
					@updateRefreshFilters="onUpdateFilters(defaultFilter)"
					:is-create="false"
					:is-settings="false"
					:is-export="isExport()"
					is-export-permissions
					@updateExport="onExport"
			></main-table-all-back>

			<!--			@updateSettings="onSettingsOpen"-->
			<!--			@updateEvent="onEvent"-->
			<!--			@updateEdit="onEdit"-->

		</div>

		<statement-new-item
				v-if="isStatementNewItem"
		></statement-new-item>

		<preload v-if="isPreloader"></preload>
		<!--		onManager-->
		<manager-statements-form
				v-if="isManagerStatementsForm"
				:managerStatementsItem="managerStatementsItem"
				:managerStatementsMonth="managerStatementsMonth"
				:managerStatementsDepartments="managerStatementsDepartments"
				@updateCloseDialog="onManagerCloseDialog"
		></manager-statements-form>
		<!--		onManager-->

		<!--		Month-->
		<month-salary-form
				v-if="isMonthSalaryForm"
				:dispatcherStatementsItem="dispatcherStatementsItem"
				:otherStatementsItem="otherStatementsItem"
				:managerStatementsDepartments="statementsDefaultDepartments"
				@updateCloseDialog="onMonthSalaryCloseDialog"
				@updateMonthSafety="onMonthSafety"
				@updateMonthDispatcher="onMonthDispatcher"
				@updateClickButton="onClickButton"
				@updateMonthMod="onMonthMod"
		/>
		<!--		Month-->

		<!--		Other-->
		<other-statements-form
				v-if="isOtherStatementsForm"
				:otherStatementsItem="otherStatementsItem"
				:managerStatementsMonth="statementsDefaultMonth"
				:managerStatementsDepartments="statementsDefaultDepartments"
				@updateCloseDialog="onOtherCloseDialog"
		></other-statements-form>
		<!--		Other-->

		<!--		onDispatchers-->
		<statement-create-form
				v-if="isStatementCreateForm"
				@backFromCreate="onBackFromCreate"
				@backToMainTB="onBackToMainTB"
		></statement-create-form>
		<!--		onDispatchers-->

		<!--		onSafety-->

		<safety-statements-create
				v-if="isCreateStatements"
				@updateClose="onSafetyCloseDialog(false)"
				@updateView="onView(true)"
		></safety-statements-create>

		<safety-statements-view
				v-if="isSafetyStatementsView"
				@updateCloseViewDialog="onView(false)"
				:month="monthMod"
		></safety-statements-view>
		<!--		onSafety-->

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

		<statement-view
				v-if="isStatementView"
				@updateCloseDialog="onCloseDialogStatementView"
				@updateSave="onSaveStatementView"
				:title="svTitle"
				:name-employee="svEmployee"
				:period="svPeriod"
				:table-flag="svFlag"
				:table-header="svHeaders"
				:table-items="svItems"
		/>

	</div>
</template>

<script>
import { accountTabStatementsItems } from "@/pages/Account/constants";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import StatementNewItem from "@/pages/Account/Drawers/StatementNewItem.vue";
import ManagerStatementsForm
from "@/components/Accounting/ManagerStatements/ManagerStatementsForm/ManagerStatementsForm.vue";
import { mapActions, mapGetters } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
import StatementCreateForm
from "@/components/Accounting/dispatchers-st-ts/statements-create-form/statements-create-form.component.vue";

import SafetyStatementsCreate
from "@/components/Accounting/SafetyStatements/SafetyStatementsCreate/SafetyStatementsCreate";
import SafetyStatementsView
from "@/components/Accounting/SafetyStatements/SafetyStatementsView/SafetyStatementsView";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
import OtherStatementsForm from "@/components/Accounting/OtherStatements/OtherStatementsForm/OtherStatementsForm.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import { PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import MonthSalaryForm from "@/components/Accounting/MonthSalaryForm/MonthSalaryForm.vue";
import { getFormatYmToLongTitle } from "@/helper";
import StatementView from "@/pages/Account/Tabs/StatementView/StatementView.vue";
// import { PERMISSIONS } from "@/constants/constants";
import { safetyStatementsViewHeader } from "@/pages/Accounting/SafetyStatements/constants";
import { dispatchersStatementsLoadHeader } from "@/constants/defaultHeader";

export default {
	name: "AccountTabStatements",
	components: {
		StatementView,
		MonthSalaryForm,
		DialogRemove,
		OtherStatementsForm,
		MainTableAllBack,
		StatementCreateForm,
		Preload,
		ManagerStatementsForm,
		StatementNewItem,
		ItemInfoRow,
		SafetyStatementsCreate,
		SafetyStatementsView,
	},
	props: {
		isGeneralTitle: {
			type: Boolean,
			default: true,
		},
		textGeneralTitle: {
			type: String,
			default: "Statements Items",
		},
	},
	computed: {
		...mapGetters([
			"managerStatementsMonth",
			"managerStatementsDepartments",
			"managerStatementsItem",
			"statementsDefaultRows",
			"statementsDefaultLimit",
			"statementsDefaultOrder",
			"statementsDefaultSort",
			"statementsDefaultSum",
			"statementsDefaultTotal",
			"statementsDefaultTotals",
			"statementsDefaultFilters",
			"statementsDefaultDepartments",
			"statementsDefaultMonth",
			"permissionsDefault",
			"dispatcherStatementsCreateView",
			"safetyStatementsView",
		]),
		getHeaders() {
			return accountTabStatementsItems;
		},

		getHeaderSafetyStatementsViewHeader() {
			return safetyStatementsViewHeader;
		},
		getHeaderDispatchersStatementsLoadHeader() {
			return dispatchersStatementsLoadHeader;
		},
	},
	data: () => ({
		flag: 'AccountTabStatements',

		isPreloader: false,
		isOtherStatementsForm: false,
		isMonthSalaryForm: false,
		isManagerStatementsForm: false,
		isStatementNewItem: false,
		isStatementCreateForm: false,
		isCreateStatements: false,
		isSafetyStatementsView: false,

		bonus: null,
		charge: null,
		salary: null,
		total: null,

		defaultFilter: null,

		otherStatementsItem: null,
		dispatcherStatementsItem: null,
		monthSalaryItem: null,

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,

		month: null,
		monthMod: null,
		dispatcher_id: null,

		isStatementView: false,
		svTitle: null,
		svEmployee: null,
		svPeriod: null,
		svFlag: null,
		svHeaders: null,
		svItems: null,
	}),

	methods: {
		...mapActions([
			'getManagerStatements',
			'getManagerStatementsFilters',
			'getStatementsDefaultList',
			'getStatementsDefaultFilters',
			'getStatementsDefaultCreate',
			'getStatementsMonthCreate',
			'deleteStatementsDefaultList',
			'onExportLink',
			'onSafetyStatementsCreateView',
			'onDispatcherStatementsCreateView',
			'onDispatcherStatements',
			'onDispatcherStatements',
			'onSafetyStatementsSave',
		]),

		async onCloseDialogStatementView() {
			this.isStatementView = false;
			// await this.getStatementsDefaultList();
			// await this.getStatementsDefaultFilters();
		},
		onSaveStatementView() {

			this.onCloseDialogStatementView();

		},

		onMonthMod(month) {
			this.month = month;
			this.monthMod = getFormatYmToLongTitle(this.month);
		},

		async onExport(values) {
			values.id = this.id;
			values.setting = [
				"id",
				"month",
				"created",
				"department",
				"employee",
				"manager",
				"bonus",
				"charge",
				"salary",
				"total",
			];

			await this.onExportLink({ values, requestKey: 'statements-all', isSetting: 1 });
		},

		isExport() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_ST_TS, PERMISSIONS.EXPORT ];
			return getPermissionsMod({ list, path });
		},

		async onUpdateFilters(filters, isWithoutPayload, isWithoutFilters) {
			if (!isWithoutPayload) this.isPreloader = true;
			await this.getStatementsDefaultList(filters);
			if (!isWithoutFilters) await this.getStatementsDefaultFilters(filters);
			if (!isWithoutPayload) this.isPreloader = false;
		},

		async onList(values) {
			this.isPreloader = true;
			const { value, flag } = values;
			this.defaultFilter = value;

			switch (flag) {
				case "sorting":
					await this.getStatementsDefaultList(value);
					this.isPreloader = false;
					break;
				case "page":
					await this.onUpdateFilters(value, 1, 1);
					this.isPreloader = false;
					break;
				default:
					await this.onUpdateFilters(value, 1);
					this.isPreloader = false;
			}
		},

		async onClickButton(args) {
			const { key, item } = args;

			this.activeItem = item;
			if ( key === 'delete1') {
				const title = TITLE.REMOVE_STATEMENTS;
				const text = TEXT.REMOVE_STATEMENTS;
				this.onRemoveDialog({ title, text });
				// const { id } = this.activeItem;
				// await this.deleteStatementsDefaultList(id);
			}
			if (key === 'openLoads') {
				this.$set(item, 'type', 2); // добавили реактивно
				this.activeItem = item;

				await this.onSafetyStatementsCreateView(item);

				this.$emit('updateView');
				// this.isSafetyStatementsView = true;

				this.svTitle = 'Safety loads';
				this.svEmployee = item.employee;
				this.svPeriod = this.monthMod;
				this.svFlag = 'safety-st-view';
				this.svItems = this.safetyStatementsView.rows;
				this.svHeaders = this.getHeaderSafetyStatementsViewHeader;
				this.isStatementView = true;

			}
			if (key === 'openLoadsDispatcher') {
				this.$set(item, 'type', 2); // добавили реактивно
				this.activeItem = item;
				this.dispatcher_id = item.dispatcher_id;

				const dispatcher_id = item.dispatcher_id;
				const date = this.month;
				const type = 2;

				await this.onDispatcherStatementsCreateView({ dispatcher_id, date, type });

				this.svTitle = 'Dispatcher loads';
				this.svEmployee = item.personal_name;
				this.svPeriod = this.monthMod;
				this.svFlag = 'viewAllLoads';
				this.svItems = this.dispatcherStatementsCreateView.dispatchers;
				this.svHeaders = this.getHeaderDispatchersStatementsLoadHeader;
				this.isStatementView = true;

			}

		},

		// async openLoads(id) {
		// 	this.id = id;
		// 	this.loadInfoDate = this.chosenDate ? this.chosenDate : this.selectedValue.date;
		// 	const payL = { id, date: this.loadInfoDate };
		// 	await store.dispatch("getLoadInfo", payL).then(() => {
		// 		this.infoLoadsShow = true;
		// 		this.showCds = false;
		// 	});
		// },
		async onRemove() {
			const { id } = this.activeItem;
			await this.deleteStatementsDefaultList(id);
			this.onCloseRemove();
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		// onDispatchers
		onDispatchers() {
			this.isStatementCreateForm = true;
		},
		async onBackToMainTB() {
			// this.infoLoads = false;
			this.isStatementCreateForm = false;
			// this.getList();
			await this.getStatementsDefaultList();
			await this.getStatementsDefaultFilters();

		},
		async onBackFromCreate() {
			this.isStatementCreateForm = false;
			// this.infoLoads = false;
			await this.getStatementsDefaultList();
			await this.getStatementsDefaultFilters();

		},
		// onDispatchers

		// onSafety
		onSafety() {
			this.isCreateStatements = true;
			this.monthMod = null;
		},
		async onSafetyCloseDialog() {
			this.isCreateStatements = false;
			await this.getStatementsDefaultList();
			await this.getStatementsDefaultFilters();

		},
		onView(value) {
			this.isSafetyStatementsView = value;
		},
		// onSafety

		// onOther onStatementsCreate
		async onOtherCloseDialog() {
			this.monthSalaryItem = null;
			this.otherStatementsItem = null;
			this.isOtherStatementsForm = false;
			await this.getStatementsDefaultList();
			await this.getStatementsDefaultFilters();

		},
		async onMonthSalaryCloseDialog() {
			await this.getStatementsDefaultList(this.defaultFilter);
			await this.getStatementsDefaultFilters(this.defaultFilter);
			this.monthSalaryItem = null;
			this.otherStatementsItem = null;
			this.isMonthSalaryForm = false;

		},
		async onMonthSafety(args) {
			const newArgs = { ...args, type: 2 };
			await this.onSafetyStatementsSave(newArgs);

			await this.getStatementsDefaultList(this.defaultFilter);
			await this.getStatementsDefaultFilters(this.defaultFilter);
			this.monthSalaryItem = null;
			this.otherStatementsItem = null;
			this.isMonthSalaryForm = false;

		},
		async onMonthDispatcher(args) {
			const newArgs = { ...args, type: 2 };
			await this.onDispatcherStatements(newArgs);

			await this.getStatementsDefaultList(this.defaultFilter);
			await this.getStatementsDefaultFilters(this.defaultFilter);
			this.monthSalaryItem = null;
			this.otherStatementsItem = null;
			this.isMonthSalaryForm = false;

		},

		async onMonthSalaryCreate() {

			this.isPreloader = true;

			await this.getStatementsMonthCreate();

			this.isMonthSalaryForm = true;

			this.isPreloader = false;
		},

		async onStatementsDefaultCreate() {
			this.isPreloader = true;

			await this.getStatementsDefaultCreate();

			this.isOtherStatementsForm = true;

			this.isPreloader = false;
		},
		// onOther onStatementsCreate

		// onManager
		async onManagerCloseDialog() {
			this.isPreloader = true;
			this.isManagerStatementsForm = false;
			await this.getStatementsDefaultList();
			await this.getStatementsDefaultFilters();
			this.isPreloader = false;
		},

		async onManager() {
			this.isPreloader = true;
			const filters = {
				limit: 15,
				order: "invoice_id",
				page: 1,
				sort: "desc"
			};

			await this.getManagerStatements(filters);
			await this.getManagerStatementsFilters(filters);

			this.isManagerStatementsForm = true;

			this.isPreloader = false;
		},
		// onManager

		setNewItem(e, id, name) {
			this.$emit('updateNewItem', { e, id, name });
		},
		funToLocaleString(number) {
			return number.toLocaleString("ru-RU", {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		},
	},
	mounted() {
		// const filters = {
		// 	limit: 15,
		// 	order: "filter_id",
		// 	page: 1,
		// 	sort: "desc"
		// };
		//
		// await this.getManagerStatements(filters);
		// await this.getManagerStatementsFilters(filters);

		// await this.getStatementsDefaultList();
		// await this.getStatementsDefaultFilters(filters);

		// await this.onUpdateFilters();
		// console.log('%c [  this.statementsDefaultSum  ] ', 'color:#bada55', typeof this.statementsDefaultSum, this.statementsDefaultSum );
		// if (this.statementsDefaultSum) {
		// 	const { sum_bonus, sum_charge, sum_salary, sum_total } = this.statementsDefaultSum;
		//
		// 	this.bonus = this.funToLocaleString(Number(sum_bonus));
		// 	this.charge = this.funToLocaleString(Number(sum_charge));
		// 	this.salary = this.funToLocaleString(Number(sum_salary));
		// 	this.total = this.funToLocaleString(Number(sum_total));
		// }

		const date = new Date();
		this.month = `${ date.getFullYear() }-${ String(date.getMonth() + 1).padStart(2, '0') }-01`;
		this.monthMod = getFormatYmToLongTitle(this.month);
	},

	watch: {
		statementsDefaultSum(value, oldValue) {
			if (value !== oldValue) {
				const { sum_bonus, sum_charge, sum_salary, sum_total } = value;

				this.bonus = this.funToLocaleString(Number(sum_bonus));
				this.charge = this.funToLocaleString(Number(sum_charge));
				this.salary = this.funToLocaleString(Number(sum_salary));
				this.total = this.funToLocaleString(Number(sum_total));
			}
		},
		managerStatementsItem(value, oldValue) {
			if (value !== oldValue) {
				this.otherStatementsItem = value;
			}
		},
		dispatcherStatementsCreateView(value, oldValue) {
			if (value !== oldValue) {
				this.dispatcherStatementsItem = value;
			}
		},
		// managerStatementsItem(value, oldValue) {
		// 	if (value !== oldValue) {
		// 		this.managerStatementsItemList = value;
		// 	}
		// },
	},
};
</script>

<!--<style lang="scss">-->

<!--.statementsItems {-->
<!--	.customBtn {-->
<!--		padding: 0 20px;-->
<!--	}-->
<!--	//.btnManager {-->
<!--	//-->
<!--	//}-->
<!--	//.btnDispatchers {-->
<!--	//-->
<!--	//}-->
<!--	//.btnSafety {-->
<!--	//-->
<!--	//}-->
<!--}-->
<!--</style>-->
<style scoped lang="scss">
@import "AccountTabStatements";

</style>
